<template>

  <div class="container">

    <div class="header-layout">
      <div class="header-title-view">可重启智能接听服务</div>
      <div class="header-desc-view">或停用服务</div>
    </div>

    <div class="card-layout">
      <!-- 开启服务的卡片 -->
      <div class="item-layout open-layout">
        <img class="item-icon-view" src="@/assets/service_open_icon.png">
        <div class="item-title-view">服务未开启成功或出现服务故障</div>
        <div class="item-desc-view">请点击下方根据步骤重启服务</div>
        <div class="item-op-view open-op-view" @click="openService">重启服务</div>
      </div>

      <!-- 关闭服务的卡片 -->
      <div class="item-layout close-layout">
        <img class="item-icon-view" src="@/assets/service_close_icon.png">
        <div class="item-title-view">不再需要智能接听服务</div>
        <div class="item-desc-view">可点击下方按照提示停用服务</div>
        <a @click="closeService" style="text-decoration: none">
          <div class="item-op-view close-op-view">停用服务</div>
        </a>
      </div>
    </div>

  </div>

</template>

<script>

import TitleBarStore from '@/components/widgets/TitleBarStore'
import lubanapi from '@/lubanapi'

export default {
  name: 'ServicePage',

  methods: {

    openService () {
      this.$router.push({
        name: 'bind_call_forward',
        params: {
          from: 'server'
        }
      })
      lubanapi.reportseer('AICall_Service_Switch_Page_Open_Service_Button_Click')
    },

    closeService () {
      // 直接拨号
      this.$router.push({
        name: 'closeaipage'
      })
      lubanapi.reportseer('AICall_Service_Switch_Page_Close_Service_Button_Click')
    }
  },

  mounted () {
    TitleBarStore.store.changeWhiteText(true)
    TitleBarStore.store.changeBackGround('#3265E4')
    lubanapi.reportseer('AICall_Service_Switch_Page_Shown')
  }
}
</script>

<style scoped>

.container {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #F7F7F9;
  overflow-y: scroll;
}

/** 头部begin */

.header-layout {
  width: 100%;
  background-color: #3265E4;
  height: 12rem;
  box-sizing: border-box;
  padding-top: 2rem;
  position: absolute;
}

.header-title-view {
  width: 100%;
  text-align: center;
  color: white;
  font-family: PingFangSC-Medium;
  font-size: 1.5rem;
}

.header-desc-view {
  width: 100%;
  text-align: center;
  color: white;
  font-family: PingFangSC-Medium;
  font-size: 1.5rem;
}

/** 头部end */

.card-layout {
  width: 90%;
  position: absolute;
  margin-top: 8.5rem;
  margin-left: 5%;

  display: flex;
  flex-direction: column;
  align-items: center;
}

/** 卡片begin */

.item-layout {
  width: 100%;
  background-color: white;
  border-radius: 0.5rem;
}

.item-icon-view {
  width: 2.6rem;
  height: 2.6rem;
  margin-top: 2rem;
}

.item-title-view {
  color: black;
  font-size: 1rem;
  margin-top: 0.8rem;
}

.item-desc-view {
  color: #999999;
  font-size: 0.8rem;
  margin-top: 0.2rem;
}

.item-op-view {
  border-radius: 0.3rem;
  font-size: 1rem;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin: 1rem;
}

.close-layout {
  margin-top: 1rem;
}

.open-op-view {
  background-image: linear-gradient(135deg, #5EDB3B 0%, #5DE588 100%);
  color: white;
}

.close-op-view {
  background: #FFFFFF;
  border: 0.05rem solid #EEEEEE;
  color: black;
}

/** 卡片end */

</style>



// WEBPACK FOOTER //
// src/components/setting/ServicePage.vue